registerComponent("blocks/radio", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Este componente não tem comportamento: o que havia aqui era só a linha
 * comentada que criava o wrapper da biblioteca de 2020, que saiu do bundle na
 * Fase 2. O estado visual do radio é `input:checked` no LESS, e o erro de
 * validação vem do formulário que o contém, por `Asa.formulario`. O arquivo
 * fica para o registro acontecer — é ele que marca `data-initialized="true"`
 * na raiz, que é o que o `browser-check` confere.
 */

});
